import API from './api';

export const managerService = {
  // Admin: Get all employee-manager mappings
  getAllMappings: () => API.get('/managers/all-mappings'),

  // Admin: Get list of employees (for dropdowns)
  getPotentialManagers: () => API.get('/managers/list'),

  // Admin: Assign a manager
  assignManager: (data) => API.post('/managers/assign', data),

  // Employee: Get my reporting manager
  getMyManager: () => API.get('/managers/my-manager'),

  // Employee: Change my reporting manager
  changeManager: (data) => API.post('/managers/change-manager', data),
};